// src/services/api/index.ts
export { apiClient, buildQueryParams, handleApiError, createFormData } from './base';

// Servizi esistenti
export { authService, AuthService } from './auth';
export { userService, UserService } from './users';
export { requestService, RequestService } from './requests';
export { taskService, TaskService } from './tasks';
export { clientService, ClientService } from './clients';
export { articleService, ArticleService } from './articles';
export { dashboardService, DashboardService } from './dashboard';
export { commentService, CommentService } from './comments';
export { attachmentService, AttachmentService } from './attachments';
export { cacheService, CacheService } from './cache';
export { externalDataService, ExternalDataService } from './external-data';
export { notificationService, NotificationService } from './notifications';
export { pdfService } from './pdf';

// Nuovi servizi allineati con il backend
export { requestService as requestsNew } from './requests-new';
export { taskService as tasksNew } from './tasks-new';
export { commentService as commentsNew } from './comments-new';
export { checklistItemService } from './checklist-items';
export { userService as usersNew } from './users-new';
export { requestArticleService } from './request-articles';

// Import services for the combined object
import { authService } from './auth';
import { userService } from './users';
import { requestService } from './requests';
import { taskService } from './tasks';
import { clientService } from './clients';
import { articleService } from './articles';
import { dashboardService } from './dashboard';
import { commentService } from './comments';
import { attachmentService } from './attachments';
import { cacheService } from './cache';
import { externalDataService } from './external-data';
import { notificationService } from './notifications';
import { pdfService } from './pdf';

// Import nuovi servizi allineati con il backend
import { requestService as requestsNew } from './requests-new';
import { taskService as tasksNew } from './tasks-new';
import { commentService as commentsNew } from './comments-new';
import { checklistItemService } from './checklist-items';
import { userService as usersNew } from './users-new';
import { requestArticleService } from './request-articles';

// Export all services as a single object for convenience
export const apiServices = {
  // Servizi esistenti
  auth: authService,
  users: userService,
  requests: requestService,
  tasks: taskService,
  clients: clientService,
  articles: articleService,
  dashboard: dashboardService,
  comments: commentService,
  attachments: attachmentService,
  cache: cacheService,
  externalData: externalDataService,
  notifications: notificationService,
  pdfService: pdfService,

  // Nuovi servizi allineati con il backend
  requestsNew: requestsNew,
  tasksNew: tasksNew,
  commentsNew: commentsNew,
  checklistItems: checklistItemService,
  usersNew: usersNew,
  requestArticles: requestArticleService,
};
